// =============================================================================
// CONSTANTS.JS — Dawn theme global constants
// =============================================================================
// Shared constants and PubSub event names used by Dawn theme components.
// Loaded first in theme.liquid's global script chain (before pubsub.js).

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
